var AT_Main = {

	getWidthBrowser : function() { // Get width browser
		var myWidth;

		if( typeof( window.innerWidth ) == 'number' ) {
			//Non-IE 
			myWidth = window.innerWidth;
		} 
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
			//IE 6+ in 'standards compliant mode' 
			myWidth = document.documentElement.clientWidth; 
		} 
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
			//IE 4 compatible 
			myWidth = document.body.clientWidth;  
		}

		return myWidth;
	}
	
	,checkLayout : function() { // Function to check level of layout
		if(jQuery("#checkLayout .d-sm-block").css("display") == "block")
			return 1; //mobile layout
		else if(jQuery("#checkLayout .d-md-block").css("display") == "block")
			return 2; //tablet potrait layout
		else if(jQuery("#checkLayout .d-lg-block").css("display") == "block")
			return 3; //tablet landscape/medium desktop layout
		else if(jQuery("#checkLayout .d-xl-block").css("display") == "block")
			return 4; //desktop layout
	}
  
	,homeSlideshow : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){
              
                var _delay_time = '';
                if(jQuery(value).data('autoplay')){
                	_delay_time = jQuery(value).data('time');
                }
              
                var swiper = new Swiper('.swiper-container', {
                  	autoplay: _delay_time
                  	,loop: true
                    ,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: jQuery(value).data('animation')
                  	,setWrapperSize: false
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });	
                          
                        });
                    }
                });
            });
        }
    }
  
  	,homeIE : function(){
        if(jQuery('.home-slideshow-wrapper').length){
            jQuery('.home-slideshow-wrapper').each(function(index,value){
              
                var _delay_time = '';
                if(jQuery(value).data('autoplay')){
                  _delay_time = jQuery(value).data('time');
                }
              
                var swiper = new Swiper('.swiper-container', {
                    autoplay: _delay_time
                  	,loop: true
                  	,pagination: '.swiper-pagination'
                    ,paginationClickable: '.swiper-pagination'
                    ,nextButton: '.swiper-button-next'
                    ,prevButton: '.swiper-button-prev'
                    ,spaceBetween: 30
                    ,scrollbarDraggable: true
                    ,effect: 'fade'
                  	,setWrapperSize: true
                    ,onImagesReady: function(swiper){
                    	var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
                      		slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
                      	$(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
                      	$(swiper.container[0]).find('.swiper-slide').each(function(){
                          var _this = $(this);
                          _this.find('.video-slide').show();
                          _this.find('.video-slide video').css({
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                          });	
                          
                        });
                    }
                });
            });
        }
    }
	
	,stickMenu : function() {
		var _height_content = $('#main-content').height();
		if (_height_content >= 400) {
		var enable_stick = jQuery(".header-content").data('stick');
		if(enable_stick){
		  //Keep track of last scroll
			var lastScroll = 0;
			var header = jQuery(".header-content");
			var body_content = jQuery("#body-content");

			jQuery(window).scroll(function() {
				//Sets the current scroll position
				var st = jQuery(this).scrollTop();
				
				//Determines up-or-down scrolling
				
					if (st > lastScroll) {
					
					//Replace this with your function call for downward-scrolling
					if (st > 10 ) {
						header.addClass("header-fixed");
						body_content.addClass("has-header-fixed");
					}
					}
					else {
						//Replace this with your function call for upward-scrolling
						if (st < 10) {
							header.removeClass("header-fixed");
							body_content.removeClass("has-header-fixed");
						}
					}
			
				//Updates scroll position
				lastScroll = st;
			});
		}
		}

	}
  
    ,fixNavHeader : function() {
      var _header_style = parseInt(jQuery(".header-container").data('style'));

      if(_header_style == 4 || _header_style == 4){
        jQuery('.mobile-version').removeClass('d-lg-none');
        jQuery('.mobile-version').addClass('d-xl-none');
      }

      if(_header_style == 7){
        jQuery('.mobile-version').removeClass('d-lg-none');
      }

    }
	
	,toTopButton : function(){
		var to_top_btn = $("#scroll-to-top");
		if( 1 > to_top_btn.length ){
			return;
		}
		$(window).on( 'scroll' , function() {
			var b = jQuery(this).scrollTop();
			var c = jQuery(this).height();
			if (b > 100) { 
				var d = b + c / 2;
			}
			else { 
				var d = 1 ;
			}

			if (d < 1000 && d < c) { 
				jQuery("#scroll-to-top").removeClass('on off').addClass('off'); 
			} else {
				jQuery("#scroll-to-top").removeClass('on off').addClass('on'); 
			}
		});

		to_top_btn.on( 'click',function (e) {
			e.preventDefault();
			jQuery('body,html').animate({scrollTop:0},800,'swing');
		});
	}

	,mailchipPopup : function() {
		var expire = jQuery("#mailchimp-popup").data('expires');
		if (jQuery.cookie('mycookie')) {
			//it hasn't been one days yet
		}
		else {
        	setTimeout(function(){
	            /*jQuery.fancybox(
					jQuery('#mailchimp-popup'),
					{
						'autoDimensions': false
						,'width'		: 550
						,'transitionIn' : 'elastic'
						,'beforeShow': function(){
						    jQuery('.fancybox-overlay').addClass('newsletter-opened');
						    
						  }
					}

				);*/
				jQuery('#mailchimp-popup').modal('show');
				jQuery('.modal-backdrop').css('z-index','2040');
				jQuery('#mailchimp-popup').css('padding-right','');
          },'1000');
		}
		jQuery('.close').on('click', function(e){
			jQuery('.modal-backdrop').removeClass('show');
			jQuery('body').removeClass('modal-open');
			jQuery('#mailchimp-popup').removeClass('show');
			jQuery('.modal-backdrop').css('z-index','1040');
			jQuery('.modal-backdrop').remove();

		});
		jQuery.cookie('mycookie', 'true', { expires: expire });
	}

    ,transformPopup : function() {
    	$(document).mousemove(function(e) {
				var _x = $(window).width()/2;
				var _y = $(window).height()/2;
				var centroX = e.clientX - _x;
				var centroY = _y - (e.clientY + 13);
				var degX = centroX * 0.04;
				var degY = centroY * 0.02;
				var style = "rotateY(" + degY + "deg) rotateX(" + degX + "deg)";
				$('#mailchimp-popup').parents('.fancybox-wrap').css('transform',style);
				
		    });
    }
    ,toggleVerticalMenu : function(){
        jQuery(document).on('click', '.vertical-menu .head', function(e) {
          jQuery(this).parent().toggleClass('opened');
        });
	}
  
  	,toggleCartSidebar : function(){
		jQuery('.cart-toggle').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('.cart-sb').toggleClass('opened');
			jQuery('body').toggleClass('opened');
			jQuery('.currencies-drop .content-dropdown').removeClass('open');
		});

		jQuery('#page-body, .c-close').on('click',function () {
			jQuery('.cart-sb').removeClass('opened');
			jQuery('html,body').removeClass('opened');
            jQuery(".dropdown").removeClass("menu-mobile-open");
          
			AT_Main.fixReturnScroll();
		}); 
      
      	jQuery('.am-close').on('click',function (e) {
          jQuery('#layer-addcart-modal').removeClass('show');
		});
	}

  	,toggleFilterSidebar : function(){
		jQuery('.filter-icon').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('body').toggleClass('sidebar-opened');
		});

		jQuery('#page-body').on('click',function () {
			jQuery('html,body').removeClass('sidebar-opened');
			AT_Main.fixReturnScroll();
		}); 	
      
      	jQuery('.f-close').on('click',function () {
          	jQuery('#sidebar').removeClass('opened');
			jQuery('html,body').removeClass('sidebar-opened');
			AT_Main.fixReturnScroll();
		});
      
      	jQuery('.filter-icon-order').on('click',function (e) {
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery('body').toggleClass('order-sidebar-opened');
		});

		jQuery('#page-body').on('click',function () {
			jQuery('html,body').removeClass('order-sidebar-opened');
			AT_Main.fixReturnScroll();
		}); 	
      
      	jQuery('.fof-close').on('click',function () {
			jQuery('html,body').removeClass('order-sidebar-opened');
			AT_Main.fixReturnScroll();
		});
	}
  
    ,parallaxIt : function() {
		if($(".parallax-section").length == 0) 
			return;
		$.fn.parallaxScroll = function(xpos, speedFactor, outerHeight) {
			var elem = $(this);
			var getHeight;
			var firstTop;
			var paddingTop = 0;

			//get the starting position of each element to have parallax applied to it      
			$(this).each(function(){
				firstTop = $(this).offset().top;
			});

			getHeight = function(jqo) {
				return jqo.outerHeight(true);
			};

			var j$element, top, height, pos;

			function update(){

				pos = $(window).scrollTop();             
				firstTop = elem.offset().top;
				height = getHeight(elem);
				
				if (pos + $(window).height() < firstTop || pos > firstTop + height) {
				  return;
				}

				if(AT_Main.checkLayout()!=1)
				  elem.css('backgroundPosition', xpos + " " + Math.round((firstTop - pos) * speedFactor) + "px",0);   
				else         
				  elem.css('backgroundPosition', xpos + " " + -Math.round((firstTop - pos) * speedFactor) + "px",0);  
			}       

			window.addEventListener('scroll', function(){ 
				update(); 
			}, false)

			update();
		}; 

		$(".parallax-section").parallaxScroll("50%",0.1);
	}
      
    ,handleGridList : function(){
        if ($.cookie('view-cata-list') == "yes") {
            $("body").addClass("view-cata-list");
          	$(".templateCollection .mode-view-item").removeClass("product-grid-item");$(".templateCollection .mode-view-item").addClass("product-list-item");
          	$(".grid-list .grid").removeClass("active");$(".grid-list .list").addClass("active");
        }
        var _class = $('.product-content').attr('class');
        if(jQuery('.list').hasClass('active')) {
        	$('.product-content').removeClass('text-center');
        	$('.product-content').removeClass('text-left');
        	$('.product-content').removeClass('text-right');
        }
        jQuery("body").on("click", ".grid", function() {
            var e = jQuery(this).closest(".view-mode");
            $.cookie('view-cata-list','no',  {expires: 1, path: '/'});
          	jQuery("body").removeClass("view-cata-list");
          	$(".templateCollection .mode-view-item").removeClass("product-list-item");
          	$(".templateCollection .mode-view-item").addClass("product-grid-item");
          	$(".grid-list .list").removeClass("active");
          	$(".grid-list .grid").addClass("active");
          	$('.product-content').addClass(_class);
        }),jQuery("body").on("click", ".list", function() {
            var e = jQuery(this).closest(".view-mode");
            $.cookie('view-cata-list','yes', {expires: 1, path: '/'});
          	jQuery("body").addClass("view-cata-list");
          	$(".templateCollection .mode-view-item").removeClass("product-grid-item");
          	$(".templateCollection .mode-view-item").addClass("product-list-item");
          	$(".grid-list .grid").removeClass("active");
          	$(".grid-list .list").addClass("active");
            $('.product-content').removeClass('text-center');
          	$('.product-content').removeClass('text-left');
        	$('.product-content').removeClass('text-right');
        })
    }
     
    ,instagram_listener : function(){
		if( jQuery('#instagram_list_widget').length > 0 ){
		  
			if( 'undefined' === typeof Instafeed ){
				console.log(" Instafeed has not defined yet! ");
				return;
			}
		  
			var instagram_list_widget;
			jQuery('#instagram_list_widget').each(function( index,value ){
				instagram_list_widget = new Instafeed({
					get: "user"
					,target		: "instagram_list_widget"
					,accessToken	: jQuery(value).data('token-key')
					,userId		: jQuery(value).data('uid')
					//,clientId	: $(value).data('cid')
					,limit		: jQuery(value).data('limit')
                    ,resolution : "low_resolution"
                    ,resolution2 : "standard_resolution"
			});
			instagram_list_widget.run();
		  });
		  
		}		
	}  
    ,handleShowBy : function(){
      jQuery('.show-by #show-by-box a').click(function(t){
        t.preventDefault();
        var e = $(this),
            a = e.attr("href");
        Shopify.queryParams.view = a;
        location.search = jQuery.param(Shopify.queryParams);
      });
    }
  
    ,handleOrderFormQty : function(){
      jQuery("body").on("click",".global-product-info-qty-plus",function(){
        q = $(this).prev();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 0 : value;
        value++;
        q.val(value);
      });

      jQuery("body").on("click",".global-product-info-qty-minus",function(){
        q = $(this).next();
        var value = parseInt(q.val(), 10);
        value = isNaN(value) ? 1 : value;
        if(value > 1){
          value--;
          q.val(value);
        }
      });
    }
  
  	,effectNavigation : function(){ // Make hover effect of navigation
      
      	jQuery(".top-account-holder").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});
      
      	jQuery(".currency-block").hover(function(e){
			jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
		},function(e){
			jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
		});
      
      	jQuery(document).on('click','.searchbox>a',function(e){
            $(this).parents().find('.searchbox').toggleClass('open');
  		});
      
        jQuery('#city-phone-numbers').on("change", function(e) {
          var _newcity = jQuery(e.currentTarget).find(':selected').attr('value');
          $('#city-phone-number-label').html(_newcity);
        });
      
	}

	,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
		var windowW = jQuery(window).width();
		if ($('body').hasClass('sidebar-style')) {
			jQuery('#page-body, #page-body .mobile-version').css("width", windowW + 'px');
		} else {
			jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
		}
		
	}

	,fixReturnScroll : function() {
		jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', ''); 
	}

  	,fixButton : function(){
      	jQuery(".product-wrapper .product-head").each(function(e){
            if($(this).children().hasClass('wrapper-countdown')){
              	$(this).find('.product-button').addClass('fix');
            }
  		});
    }
  
  	,handleReviews: function() {
        SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
    }
    
	,menuOnMobile : function(){
		jQuery('#page-body').on('click',function () {
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("opened");
			AT_Main.fixReturnScroll();
		});
      
      	jQuery('.mm-block-icons .wishlist-target, .mm-block-icons .compare-target, .m-close').on('click',function () {
			jQuery(".menu-mobile").removeClass("opened");
			jQuery("html,body").removeClass("opened");
			AT_Main.fixReturnScroll();
		});

		jQuery(document).on('click','[data-toggle=offcanvas]',function(e){
			e.stopPropagation();
			AT_Main.fixNoScroll();
			jQuery(".menu-mobile").toggleClass("opened");
			jQuery("html,body").toggleClass("opened")
		});

		jQuery(".navbar .main-nav li").hover(function(){jQuery(this).addClass("hover")},function(){jQuery(this).removeClass("hover")});

		jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(){
			var e=jQuery(this).parents(".dropdown").first();
            if (e.hasClass("menu-mobile-open")) {
                e.removeClass("menu-mobile-open");
            } else {
                e.addClass("menu-mobile-open");
            }
		});
      
      	jQuery(document).on('click','#cata_sort_by',function(){
			var e = jQuery(this).parents('.sort-by-inner');
            if (e.hasClass("opened")) {
                e.removeClass("opened");
            } else {
                e.addClass("opened");
            }
		});


	}
	
	,handleMenuMultiLine : function() {
		var outItem = "";
		var down = false;

		var top = 0;

		jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
			var target = jQuery(e.currentTarget);

			if( down && outItem != "") {
				outItem.addClass("hold");
				setTimeout(function(){
					if(outItem != "")
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				},500);

				if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
				{       
					outItem.removeClass("hold");
					down = false;
					outItem = "";
				}
			}
			else {
				outItem = "";
			}

		});

		jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

			var target = jQuery(e.currentTarget);

			if( e.pageY >= target.offset().top + 50 ) { //move down
				down = true;
			}

			if( target.hasClass("dropdown") ) { //target has child

				if(outItem == "")
					outItem = target;
			}

		});
	}
  
  	,lookbooks_initor : function(){ 
		if( jQuery('.bc-lookbooks.lookbooks.margin-row').length > 0 ){
		  
			if( 'undefined' === typeof Isotope ){
				console.log(" Isotope has not defined yet! ");
				return;
			}

			jQuery('.bc-lookbooks.lookbooks.margin-row').isotope({
			  itemSelector: '.look-item',
			  layoutMode: 'fitRows'
			});
		}
		if( jQuery('.bc-lookbooks.lookbooks.look-slider').length > 0 ){
		  
			if( 'undefined' === typeof Swiper ){
				console.log(" Swiper has not defined yet! ");
				return;
			}
          
          	$('body').addClass('carousel-lookbook');

            var swiper_look = new Swiper('.lookbooks-wrapper.look-slider', {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows : true
                },
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev', 
                pagination: '.swiper-pagination',
                paginationType: 'progress',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 30
            });
		}      
	}
	
	,fixTitle : function(){ // fix title a in filter
		jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
		jQuery(".rt a").removeAttr("title");
	}

	,filterCatalogReplace : function(collectionUrl, filter_id){
      
		var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
		var val = value.substring(value.lastIndexOf('?')); 

		collectionUrl = collectionUrl.replace(value, '');

		value = value.replace(val, '');
		value = value.replace('#', '');

		var value_arr = value.split('+');

		var current_arr = [];
		jQuery('#'+filter_id+' li.active-filter').each( function() {
		  current_arr.push(jQuery(this).attr('data-handle'));
		});

		jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
		jQuery('#'+filter_id+' li').removeClass('active-filter');

		for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
		  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
		}

		var new_data = value_arr.join('+')

		var new_url = collectionUrl+new_data+val;

		if( typeof AT_Filter != 'undefined' && AT_Filter ){
			AT_Filter.updateURL = true;
            AT_Filter.requestPage(new_url);		
		}else{
			window.location = new_url;
		}
		
	}
  
	,filterCatalog : function(){
		var currentTags = ''
			,filters 	= jQuery('.advanced-filter');

		filters.each(function() {
			var el = jQuery(this)
				,group = el.data('group');

			if ( el.hasClass('active-filter') ) { //Remove class hidden
				el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden').removeClass('hide');
			}
		});

		filters.on('click', function() {
			var el 		= jQuery(this)
				,group 	= el.data('group')
				,url 	= el.find('a').attr('href');

			// Continue as normal if we're clicking on the active link
			if ( el.hasClass('active-filter') ) {
				return;
			}
		});

		jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear

			var filter_id = jQuery(this).attr('id');
			filter_id = filter_id.replace('clear-', '');

			var collectionUrl = window.location.href;

			if(collectionUrl.match(/\?/)){
				var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

				if(string.match(/\//)){
					var str_replace = string.replace(/\//, '');
					collectionUrl = collectionUrl.replace(string, '');
					collectionUrl = collectionUrl+str_replace;
					AT_Main.filterCatalogReplace(collectionUrl, filter_id);
				}
				else{
					AT_Main.filterCatalogReplace(collectionUrl, filter_id);
				}
			}
			else{
				var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);

				collectionUrl = collectionUrl.replace(value, '');  

				value = value.replace('#', '');

				var value_arr = value.split('+');

				var current_arr = [];
				jQuery('#'+filter_id+' li.active-filter').each( function() {
				  current_arr.push(jQuery(this).attr('data-handle'));
				});

				jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
				jQuery('#'+filter_id+' li').removeClass('active-filter');

				for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
				  value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
				}

				var new_data = value_arr.join('+')

				var new_url = collectionUrl+new_data;

				if( typeof AT_Filter != 'undefined' && AT_Filter ){
					AT_Filter.updateURL = true;
		            AT_Filter.requestPage(new_url);		
				}else{
					window.location = new_url;
				}
			}

		});
		$('.filter-icon').on('click', function() {
			var _style = $('.page-cata').attr('data-style');
			var _width = window.innerWidth;
			console.log('1');
			if (_style == 'none') {
				var _filter = $('.filter-sidebar');
				if(_filter.hasClass('opened')) {
					_filter.removeClass('opened');
					if (_width > 768) {
						$('body').removeClass('show-filter');
					}
				} else {
					if (_width < 768) {
						$('body').addClass('show-filter');
					}
					_filter.addClass('opened');
				}
			} else {
				var _filter_cate = $('#sidebar');
				if(_filter_cate.hasClass('opened')) {
					_filter_cate.removeClass('opened');
					if (_width > 768) {
						$('body').removeClass('show-filter');
					}
				} else {
					if (_width < 768) {
						$('body').addClass('show-filter');
					}
					_filter_cate.addClass('opened');
				}
			}
		});
		$('.icon-filter-mobile').on('click', function(e) {
			var _parent = $(e.target).parents('.sb-filter ');
			var _parent_menu = $(e.target).parents('.sb-menu');
			var _hide_content = _parent.children('.advanced-filters');
			var _hide_menu = _parent_menu.children('.categories-menu');
			if (_hide_content.hasClass('hide')) {
				_hide_content.removeClass('hide');
			} else {
				_hide_content.addClass('hide');
			};
			if (_hide_menu.hasClass('hide')) {
				_hide_menu.removeClass('hide');
			} else {
				_hide_menu.addClass('hide');
			}
		});
		$('.close-filter').on('click', function(e){
			$('body').removeClass('show-filter');
			$('.filter-sidebar').removeClass('opened');
			$('#sidebar').removeClass('opened');
		});
		$('.show-by-button').on('click', function(e) {
			var _show = $('.show-by-inner');
			if (_show.hasClass('opened')) {
				_show.removeClass('opened');
			} else {
				_show.addClass('opened');
			}
		})
	}
	
	,swatch : function(){
        jQuery('.swatch :radio').change(function() {
          	var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
          	var optionValue = jQuery(this).val();
          	jQuery(this)
          	.closest('form')
          	.find('.single-option-selector')
          	.eq(optionIndex)
          	.val(optionValue)
          	.trigger('change');
        });
        jQuery('.currencies-drop').click(function(e){
        	var _children = $('.currencies-drop').children('.currencies');
        	console.log('click');
        	if (_children.hasClass('open')) {
        		_children.removeClass('open');
        	} else {
        		_children.addClass('open');
        	}
        })
  	}
  
  	,switchImgProduct: function() {
  		
  			$('.product-wrapper .swatch-element > input').on('change', function(e){
          	e.stopPropagation();
          	var imgUrl = $(this).data("swatch-image"),
                parent = $(this).parents('.product-wrapper'),
                imgElem = parent.find('.product-image img');
          	imgElem.parents('.product-image').addClass('img-loading');
          	imgElem.attr('src', imgUrl)
          	var fakeImg = new Image();
          	fakeImg.src = imgUrl;
            fakeImg.onload = function(event){
                imgElem.parents('.product-image').removeClass('img-loading');
            };
            fakeImg.onerror = function() {
                //Code for error loading
            };
        });
    }
      
    ,slickProductPage: function(){
        $('.slick-multi-rows').slick({
          rows: 2
          ,slidesPerRow: 2
          ,infinite: false
          ,arrows: true
          ,dots: false
          ,autoplay: false
          ,mobileFirst: true
        });

        jQuery('.slider-for-03').length && jQuery('.slider-for-03').slick({
          slidesToShow: 1
          ,slidesToScroll: 1
          ,arrows: true
          ,fade: true
          ,asNavFor: '.slider-thumbs-03'
          ,nextArrow: $('.slick-btn-03 .btn-next')
          ,prevArrow: $('.slick-btn-03 .btn-prev')
        });

        jQuery('.slider-thumbs-03').length && jQuery('.slider-thumbs-03').slick({
          infinite: false
          ,slidesToShow: 6
          ,slidesToScroll: 1
          ,asNavFor: '.slider-for-03'
          ,dots: false
          ,arrows: false
          ,focusOnSelect: true
        });

        jQuery('.slider-for-06').length && jQuery('.slider-for-06').slick({
          slidesToShow: 1
          ,slidesToScroll: 1
          ,vertical: false
          ,arrows: true
          ,fade: true
          ,asNavFor: '.slider-thumbs-06'
          ,nextArrow: $('.slick-btn-06 .btn-next')
          ,prevArrow: $('.slick-btn-06 .btn-prev')
        });

        jQuery('.slider-thumbs-06').length && jQuery('.slider-thumbs-06').slick({
          infinite: false
          ,slidesToShow: 6
          ,slidesToScroll: 1
          ,vertical: true
          ,asNavFor: '.slider-for-06'
          ,dots: false
          ,arrows: false
          ,focusOnSelect: true
        });
    }
    ,sliderthumnb : function() {
    	var _position = $('.product-image-inner').attr('data-position');
    	var _width = window.innerWidth;
    	if (_width < 768) {
  				$('.slick-gallery-image').slick({
		          infinite: false
		          ,arrows: true
		          ,fade: false
		          ,dots: false
		          ,autoplay: false
		          ,mobileFirst: true
		          ,slidesToShow: 4
		          
		    });
    	} else {
	    	if(_position == 'thumbnail-bottom') {
	    		$('.slick-gallery-image').slick({
		          infinite: false
		          ,arrows: true
		          ,fade: false
		          ,dots: false
		          ,autoplay: false
		          ,mobileFirst: true
		          ,slidesToShow: 6
		          //,variableWidth: true
		    });
	  		} else {
	  			$('.slick-gallery-image').slick({
		          infinite: false
		          ,arrows: true
		          ,vertical: true
		          ,fade: false
		          ,dots: false
		          ,autoplay: false
		          ,mobileFirst: true
		          ,slidesToShow: 4
		          
		        });
	  		}
    	};
    	

    }
  	,windowSlider : function() {
  		var _position = $('.product-image-inner').attr('data-position');

  		$( window ).resize(function() {
  		let _color = jQuery('.slick-gallery-image').attr('data-filter');
  		if(_color){
  			$('.slick-gallery-image').slick('slickUnfilter');
  		}
  		var _width = window.innerWidth;
    	if (_width < 768) {
    		$('.slick-gallery-image').slick('unslick');
  				$('.slick-gallery-image').slick({
		          infinite: false
		          ,arrows: true
		          ,fade: false
		          ,dots: false
		          ,autoplay: false
		          ,mobileFirst: true
		          ,slidesToShow: 4
		    });
    	} else {
	    	$('.slick-gallery-image').slick('unslick');
	    	if(_position == 'thumbnail-bottom') {
	    		$('.slick-gallery-image').slick({
		          infinite: false
		          ,arrows: true
		          ,fade: false
		          ,dots: false
		          ,autoplay: false
		          ,mobileFirst: true
		          ,slidesToShow: 6
		          
		    });
	  		} else {
	  			$('.slick-gallery-image').slick({
		          infinite: false
		          ,arrows: true
		          ,vertical: true
		          ,fade: false
		          ,dots: false
		          ,autoplay: false
		          ,mobileFirst: true
		          ,slidesToShow: 4
		          ,centerPadding: '50px'
		        });
	  		}
    	};
    	jQuery('.slick-gallery-image .slick-slide').each(function() {
            let _group_class = jQuery(this).find('.slick-item').attr('data-match');
           jQuery(this).addClass(_group_class);
        });
    	if(_color){
        	$('.slick-gallery-image').slick('slickFilter',_color+',.group-all');
    	}
		});
  	}
  	,scareName : function(){
        var _name_height = 0;
        jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').each(function( index,value ){
          _name_height = jQuery(value).height() > _name_height ? jQuery(value).height() : _name_height;
        });
        jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').css('max-height',_name_height);
    }        
  
  	,scareWidth : function(){
        var _name_width = 110;
        jQuery('.variants-wrapper .selector-wrapper').find('label').each(function( index,value ){
          _name_width = jQuery(value).width() > _name_width ? jQuery(value).outerWidth() : _name_width;
        });
        jQuery('.variants-wrapper .selector-wrapper').find('label').css('width',_name_width);
      	jQuery('.swatch.size').find('.header').css('width',_name_width);
      	jQuery('.swatch.color, .swatch.colour').find('.header').css('width',_name_width);
      	jQuery('.product-code span:first-child').css('width',_name_width);
      	jQuery('.product-qty, .quantity').find('label').css('width',_name_width);
    }       
  
    ,scareScreen : function(){
      	if( typeof _bc_config == "undefined" ){
          	return;
      	}
      	var _current = this;
      
      	if( _bc_config.enable_title_blance == "true" ){
          	this.scareName();
      	}      
      	
      	jQuery( document ).ajaxComplete(function( event,request, settings ) {
          if( _bc_config.enable_title_blance == "true" ){
              _current.scareName();
          }  
        });  
    }
    ,clickexpand : function() {
    	var _expand = $('.expand');
    	_expand.on('click', function(e){
    		var _dropdown = $(e.target).siblings('.dropdown-menu');
    		if (_dropdown.hasClass('show')) {
    			_dropdown.removeClass('show');
    			$(e.target).removeClass('drop-show');
    		} else {
    			_dropdown.addClass('show');
    			$(e.target).addClass('drop-show');
    		}
    	})
    }
    ,backgroundCollection : function() {
    	var _src = $('.header-collection').find('.img-collection').attr('src');
    	$('.header-collection').css('background-image','url('+ _src +')');
    }
    ,clickfaq : function() {
    	var _tagert = $('.question-faq');
    	_tagert.on('click', function(e) {
    		var _ques = $(this).attr('data-id');
    		if($(this).hasClass('open')) {
    			$(this).removeClass('open');
    			$('#'+_ques).removeClass('open');
    		} else {
    			$('#'+_ques).addClass('open');
    			$(this).addClass('open');
    		}
    		
    		
    	})
    }
    ,initBackStretch: function(){
    	var _image_1 = $('.page-404').attr('data-image1');
    	var _image_2 = $('.page-404').attr('data-image2');
		if(!$('.template404').length && !$('.templatePassword').length)
			return;
		$.backstretch([
	      _image_1,
	      _image_2
	      ], {
	        fade: 1000,
	        duration: 7000
	    });

	}
	,swatchImage : function() {
		
			var _element = $('.swatch-element');
			var _width = window.innerWidth;
			_element.on('click',function(e){
				
				_element.removeClass('check');
				$(e.target).parents(_element).addClass('check');
				var _src_image = $(e.target).attr('data-swatch-image');
				var _parent = $(e.target).parents('.product-image').find('.featured-img');
				var _parent_2 = $(e.target).parents('.product-wrapper').find('.product-head').find('.featured-img');
				var _switch = _parent.attr('data-effect');
				if (_src_image)
				{
					var _no_image = _src_image.search('no-image');
				}
				if (_width > 992) {
					if (_switch == 'switch' && _no_image == -1){
					_parent.find('.img-back').find('.back').attr('src',_src_image);
					_parent_2.find('.img-back').find('.back').attr('src',_src_image);
					} else if(_switch != 'switch' && _no_image == -1){
						_parent.find('.featured-image').attr('src',_src_image);
						_parent_2.find('.img-back').find('.back').attr('src',_src_image);
					}
				} else {
					if(_no_image == -1){
						_parent.find('.featured-image').attr('src',_src_image);
						_parent_2.find('.img-back').find('.back').attr('src',_src_image);
					}
				}
			});	
	}
	,loadmoreHP : function() {
		var _button = $('.load-more');
		jQuery(document).on('click','.gird-load', function(e){
			e.preventDefault();
			var _next_url = $(e.target).attr('data-href');
			$.ajax({
		      url: _next_url,
		      type: 'GET',
		      beforeSend: function() {
		        $(e.target).remove();
		        $('body').addClass('opened');
		      }
		    })
		    .done(function(data) {
		      // Append data
		      $('.product-load-more .row').append($(data).find('.product-load-more .row').html());
		      $('body').removeClass('opened');
		      AT_Main.swatchImage();
		      
              	Currency.convertAll('USD', Currency.currentCurrency);
              
		    });
		});
		jQuery(document).on('click','.tab-load', function(e){
			e.preventDefault();
			var _next_url = $(e.target).attr('data-href');
			var _parent = $(e.target).parents('.tab-pane').attr('id');
			console.log(_parent);
			console.log(_next_url);
			$.ajax({
		      url: _next_url,
		      type: 'GET',
		      beforeSend: function() {
		        $(e.target).remove();
		        $('body').addClass('opened');
		      }
		    })
		    .done(function(data) {
		      // Append data
		      $('#'+_parent).find('.tabs-list-row .row').append($(data).find('.tabs-list-row .row').html());
		      $('body').removeClass('opened');
		      AT_Main.swatchImage();
		      
              	Currency.convertAll('USD', Currency.currentCurrency);
              
		    });
		});
		jQuery(document).on('click','.collection-load', function(e){
			e.preventDefault();
			var _next_url = $(e.target).attr('data-href');
			console.log(_next_url);
			$.ajax({
		      url: _next_url,
		      type: 'GET',
		      beforeSend: function() {
		        $(e.target).remove();
		        $('body').addClass('opened');
		      }
		    })
		    .done(function(data) {
		      // Append data
		      $('.cata-product .row').append($(data).find('.cata-product .row').html());
		      var _grid =$('.grid-list').find('.grid');
		      if (!_grid.hasClass('active')){
		      	
		      	$('.mode-view-item').each(function(e){
		      		$(this).removeClass('product-grid-item');
		      		$(this).addClass('product-list-item');
		      		$(this).find('.product-content').removeClass('text-center');
		      	});
		      }
		      $('body').removeClass('opened');
		      AT_Main.swatchImage();
		      
              	Currency.convertAll('USD', Currency.currentCurrency);
              
		    });
		});

	}
	,clicktarget : function() {
		var _acount = $('.account-target');
		_acount.on('click', function(e){
			console.log('click');
			var _drop = $(e.target).siblings('.content-dropdown');
			if (_drop.hasClass('opened')){
				_drop.removeClass('opened');
			} else {
				_drop.addClass('opened');
			}
		});
		var _currencies_drop = $('.currency-block');
		_currencies_drop.on('click', function(e){
			var _drop =$(e.target).siblings('.content-dropdown');
			if (_drop.hasClass('opened')){
				_drop.removeClass('opened');
			} else {
				_drop.addClass('opened');
			}
		});
		var _currencies = $('.currencies li');
		_currencies.on('click',function(e){
			$(e.target).parents('.currencies').removeClass('opened');
		});
		var _with = window.innerWidth;
		if (_with < 992) {
			jQuery('.top-cart-holder').on('click', function(e) {
				e.stopPropagation();
				jQuery('.cart-dd').toggleClass('drop-show');
							
			});
		};
	}
	
	,loadingPage : function (){
		window.onload = function () {
          $('body').removeClass('loading-start');
          var _item = $('.wishlist-table').find('.wishlist-item').length;
          if (_item != 0) {
          	$('.no-wishlist-msg').remove();
          }
       };

	}
	,refreshZoom : function(){ // Update Zoom in detail page
		var enable_zoom = jQuery('.featured-image').data('zoom');
		if((jQuery('.elevatezoom').length)){

			var zoomImage = jQuery('.elevatezoom .zoom-image');

			zoomImage.elevateZoom({
				gallery				:'gallery-image' 
				,galleryActiveClass	: 'active'
				,zoomType			: 'lens'
				,cursor				: 'pointer'
				,lensShape 			: "round"
				,lensSize 			: 300
			});

			//pass the images to Fancybox
			jQuery(".elevatezoom").bind("click", function(e) {  
				var ez =   jQuery('.elevatezoom .zoom-image').data('elevateZoom'); 
				jQuery.fancybox(ez.getGalleryList(),{
					closeBtn  : false,
					helpers : {
						buttons : {}
					}
				});
				return false;
			});
		}

	}
	,zomm : function() {
		/*var zoomImage = $('.img-featured #product-featured-image');
          zoomImage.elevateZoom({
            gallery:'slick-gallery-image'
            ,galleryActiveClass: 'active'
            ,zoomType: 'lens'
            ,cursor: 'pointer'
            ,lensShape      : "round"
            ,lensSize       : 300
          });*/
      	if(window.innerWidth > 991){
	      	$('.img-featured')
			  	.zoom({
			    url: $(this).find('img').attr('data-zoom-image')
			});
      	}
	}
	,jsdetailP : function() {
		
	    $(".qty-inner .qty-up").on("click", function() {
			var oldValue = $("#quantity").val(),
				newVal = 1;
				newVal = parseInt(oldValue) + 1;
				$("#quantity").val(newVal);
		});
		$(".qty-inner .qty-down").on("click", function() {
			var oldValue = $("#quantity").val();
			if (oldValue > 1) {
				newVal = 1;
				newVal = parseInt(oldValue) - 1;
				$("#quantity").val(newVal);
			}
		});
		$('.tab-item').on('click',function(e) {
	      e.preventDefault();
	      $('.tab-item').removeClass('active');
	      $('#wear_with_item').removeClass('active');
	      $('#related_item').removeClass('active');
	      var _partent = $(e.target).parents('.tab-item');
	      var _href = _partent.children('a').attr('href');
	      if (_partent.hasClass('active')) {
	          _partent.removeClass('active');
	          $(_href).removeClass('active');
	      } else {
	        _partent.addClass('active');
	        $(_href).addClass('active');
	      }
	    });
	}
	,backrgoundMenu : function() {
		var _with = window.innerWidth;
		if (_with < 992) {
			$('.column-4').css('background','');
		}
	}
	,activeSidbarCate : function() {
		var _href_local = location.href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0]
		, _length = location.href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").length
		, _sub = jQuery('#sidebar').find('.categories-menu li')
		,_href_sub = location.href.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split(_href_local,_length)[1];
		_sub.each(function(){
			var _href_cate = jQuery(this).find('a').attr('href');
			var _check = _href_local.lastIndexOf(_href_cate);
			if(_href_cate === _href_sub){
				jQuery(this).addClass('active');
				jQuery(this).parents('.dropdown-menu').addClass('show');
				jQuery(this).parents('.dropdown-menu').siblings('.expand').addClass('drop-show');
			};

		});
		

	}
	,init : function(){
      
      	if( typeof _bc_config == 'undefined' ){
           	 console.log( " _bc_config is undefined " );
           	 return ;
        }
      
        this.stickMenu();
        this.fixNavHeader();
		this.toTopButton();
		this.mailchipPopup();
      	this.toggleVerticalMenu();
      	this.toggleCartSidebar();
      	this.toggleFilterSidebar();
      	this.parallaxIt();
      	this.handleGridList();
      	this.handleShowBy();
      	this.effectNavigation();
        this.fixButton();
		this.menuOnMobile();
		this.handleMenuMultiLine();
		this.fixTitle();
		this.filterCatalog();
        this.swatch();
      	this.switchImgProduct();
      	this.slickProductPage();
      	this.clickexpand();
      	this.backgroundCollection();
      	this.windowSlider();
      	this.sliderthumnb();
      	this.instagram_listener();
      	this.clickfaq();
      	this.initBackStretch();
      	this.loadmoreHP();
      	this.clicktarget();
      	this.swatchImage();
      	this.loadingPage();
      	this.backrgoundMenu();
      	this.zomm();
      	this.jsdetailP();
      	this.activeSidbarCate();
      	
	}
}


/* Handle when window resize */
jQuery(window).resize(function() {
    
    /* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
        AT_Main.swatchImage();
    }
    AT_Main.backrgoundMenu();

   
	/*Reset Page when fixNoScroll had called before*/
	AT_Main.fixReturnScroll();
	if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened'))
		jQuery("#page-body").trigger('click');
          
});
      
jQuery(document).ready(function($) {
	
	AT_Main.init();
  	/* Fakecrop */
    if(AT_Main.checkLayout() != 1){
        AT_Main.scareScreen();
    }
  
  AT_Main.checkLayout();
});